<template>
    <div class="container maxsize" id="mainContainer">
        <br class="my-4">
        <h1 class="subtitle"><span class="firstletter">D</span>NA <span class="firstletter">P</span>rotein <span class="firstletter">I</span>nto <span class="firstletter">M</span>usic</h1>
        <hr class="my-4">
        <div class="form-group">
            <label for="inputSequence" class="lead"><span class="firstletter">Insert</span> Protein Sequence</label>
            <textarea v-model="sequence" type="textarea" class="form-control"
                id="inputSequence" :rows="showAdvanced ? 6 : 8" placeholder="Example: ARNDCQEG"></textarea>
            <small class="form-text text-muted">Accepts uppercase or lowercase letters. Invalid characters (which do not represent an amino acid) will be played as pauses.</small>
        </div>
        <!-- <hr class="my-4">
        <div class="container-fluid" v-show="musicSheet['visible']">
            <div class="container-fluid" id="musicSheetContainer">
            </div>
            <hr class="my-4">
        </div> -->
        <div class="row">
            <div class="col-sm">
                <div class="form-group">
                    <label for="inputInstrument" class="lead"><span class="firstletter">Choose</span> Instrument</label>
                    <select v-model="selectedInstrument" class="form-control" id="inputInstrument">
                        <option v-for="option in instruments" v-bind:value="option" :key="option">
                            {{ option }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="tempo" class="lead"><span class="firstletter">Set</span> Tempo</label>
                    <input v-model="tempo" type="number" step="0.05" class="form-control">
                    <small class="form-text text-muted">Seconds between notes.</small>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row-reverse playbuttons">
            <!-- <button type="button" class="btn btn-light" v-if="showAdvanced" -->
                <!-- @click="viewSheet" id="createbutton"><span v-if="!musicSheet['visible']">Mostrar</span><span v-else>Ocultar</span> Partitura</button> -->
            <!-- <button type="button" class="btn btn-link"
            @click="downloadSong" id="downloadbutton" :disabled="!audioLoadedOffline">Download</button>
            &nbsp; -->
            <button type="button" class="btn btn-outline-info"
            @click="clearSequence" id="clearbutton">Clear</button>
            &nbsp;
            <button type="button" class="btn btn-danger"
            @click="stopSong" id="stopbutton" :disabled="!audioLoaded">Stop</button>
            &nbsp;
            <button type="button" class="btn btn-primary"
            @click="playSong" id="playbutton" :disabled="!audioLoaded">Play</button>
            &nbsp;
        </div>

        <!-- aminoacids note tuning -->
        <div class="custom-control custom-switch" id="notes-selection">
            <p>
                <input type="checkbox" class="custom-control-input" id="customSwitch" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                <label class="custom-control-label" for="customSwitch"><span class="firstletter">Tune</span> the Amino acids (optional)</label>
            </P>
            <div class="collapse" id="collapseExample">
                <div class="container-fluid">
                    <div v-for="aminoacid in aminoacids" class="inline-select" :key="aminoacid.shortName">
                        {{aminoacid.fullName}}
                        <select :value="acidsToNotes[aminoacid.value]"
                            @change="($event) => updateSelected($event, aminoacid.value)">
                            <option v-for="note in notes" v-bind:value="note" :key="note">
                                {{ note }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="clearfix"></div>
                    <br>
                    <button type="button" class="btn btn-outline-info"
                    @click="resetTuning" id="playbutton">Default</button>
            </div>
        </div>
    </div>
</template>

<script>
import { SampleLibrary } from '../libraries/Tonejs-instruments'
import { audioBufferToWav } from '../libraries/buffertowav'
import * as Tone from 'tone'
import { serverBus }  from '../main'
// import { audioBufferToWav } from 'audiobuffer-to-wav'

const aminoacids = [
  {fullName: "Alanine (A)      ", shortName: "ala", value: "A", baseNote: "C3"},
  {fullName: "Arginine (R)     ", shortName: "arg", value: "R", baseNote: "A4"},
  {fullName: "Asparagine (N)   ", shortName: "asn", value: "N", baseNote: "E4"},
  {fullName: "Aspartic acid (D)", shortName: "asp", value: "D", baseNote: "G4"},
  {fullName: "Cysteine (C)     ", shortName: "cys", value: "C", baseNote: "D3"},
  {fullName: "Glutamine (Q)    ", shortName: "gln", value: "Q", baseNote: "C4"},
  {fullName: "Glutamic acid (E)", shortName: "glu", value: "E", baseNote: "F#4"},
  {fullName: "Glycine (G)      ", shortName: "gly", value: "G", baseNote: "E32"},
  {fullName: "Histidine (H)    ", shortName: "his", value: "H", baseNote: "B3"},
  {fullName: "Isoleucine (I)   ", shortName: "ile", value: "I", baseNote: "D2"},
  {fullName: "Leucine (L)      ", shortName: "leu", value: "L", baseNote: "C2"},
  {fullName: "Lysine (K)       ", shortName: "lys", value: "K", baseNote: "D4"},
  {fullName: "Methionine (M)   ", shortName: "met", value: "M", baseNote: "A2"},
  {fullName: "Phenylalanine (F)", shortName: "phe", value: "F", baseNote: "G2"},
  {fullName: "Proline (P)      ", shortName: "pro", value: "P", baseNote: "F#2"},
  {fullName: "Serine (S)       ", shortName: "ser", value: "S", baseNote: "A3"},
  {fullName: "Threonine (T)    ", shortName: "thr", value: "T", baseNote: "G3"},
  {fullName: "Tryptophan (W)   ", shortName: "trp", value: "W", baseNote: "B2"},
  {fullName: "Tyrosine (Y)     ", shortName: "tyr", value: "Y", baseNote: "F#3"},
  {fullName: "Valine (V)       ", shortName: "val", value: "V", baseNote: "E2"},
]

const acidsToNotesOriginal = {
    "L": "C2", "I": "D2", "V": "E2", "P": "F#2", "F": "G2",
    "M": "A2", "W": "B2", "A": "C3", "C": "D3", "G": "E3",
    "Y": "F#3", "T": "G3", "S": "A3", "H": "B3", "Q": "C4",
    "K": "D4", "N": "E4", "E": "F#4", "D": "G4", "R": "A4",
}

const notes = [
  "C2", "D2", "E2", "F#2", "G2", "A2", "B2",
  "C3", "D3", "E3", "F#3", "G3", "A3", "B3",
  "C4", "D4", "E4", "F#4", "G4", "A4",
]

// var exampleSequence = "CCCCC(420)-CCWHC(117)-WCCCC(72)-YCCCC(66)-CWCFW(64)-CHWCH(51)-WCWCF(49)-CCCCY(46)-CWCCC(38)-YWCWC(37)-CCHCC(35)-WCCHC(30)-CYCCC(29)-WWWDC(26)"

// basic default export
export default {
    name: 'Aminoacids',
    methods: {
        playSong: function() {
            console.log("Playing a new sequence")
            var seqString = this.sequence.toUpperCase()

            this.instrumentsTone[this.selectedInstrument].toMaster();

            // stop any previous song
            this.stopSong()

            for (var i=0; i<seqString.length; i++) {
                var acid = seqString[i]
                if (acid in this.acidsToNotes) {
                    var note = this.acidsToNotes[acid]
                    var relativeTime = (i*this.tempo)
                    this.setMusicDelay(note, this.tempo, relativeTime)
                }
            }
            Tone.Transport.start()
        },
        // downloadSongAlternate: function() {
        //     Tone.start()
        //     var anchor = document.createElement('a')
        //     console.log("Playing a new sequence")
        //     var seqString = this.sequence.toUpperCase()
        //     // stop any previous song
        //     this.stopSong()
        //     // variables required from this
        //     var tempo = this.tempo
        //     var acidsToNotes = this.acidsToNotes
        //     var setMusicDelayDownload = this.setMusicDelayDownload
        //     // var instruments = this.instruments
        //     // var selectedInstrument = this.selectedInstrument

        //     // new approach - render outside
        //     const context = new Tone.OfflineContext(1, 20, 44100);
        //     var synth = SampleLibrary.load({
        //         instruments: this.selectedInstrument,
        //         ext: ".[wav|mp3|ogg]",
        //         baseUrl: "tonejs-instruments/samples/",
        //         context: context,
        //         // onload: () => {
        //         //     console.log('loaded')
        //         //     playOffline(anchor, seqString, synth, context)
        //         // }
        //     }).toMaster()
        //     console.log(synth)

        //     setTimeout(function() {
        //         console.log('recording')
        //         var startingTime = 1
        //         for (var i=0; i<seqString.length; i++) {
        //             var acid = seqString[i]
        //             if (acid in acidsToNotes) {
        //                 var note = acidsToNotes[acid]
        //                 var relativeTime = (i*tempo + startingTime)
        //                 setMusicDelayDownload(note, tempo, relativeTime, synth)
        //             }
        //         }
        //         Tone.Transport.start()
        //     }, 1000)

        //     setTimeout(function() {
        //         context.render().then(buffer => {
        //             console.log('downloading')
        //             console.log(buffer)
        //             var audioBuffer = buffer._buffer
        //             console.log(audioBuffer)
        //             var wav = audioBufferToWav(audioBuffer)
        //             var blob = new window.Blob([ new DataView(wav) ], {
        //                 type: 'audio/wav'
        //             })
        //             var url = window.URL.createObjectURL(blob)
        //             anchor.href = url
        //             anchor.download = 'audio.wav'
        //             anchor.click()
        //             window.URL.revokeObjectURL(url)
        //         })
        //     }, 2000 + this.tempo * seqString.length * 1000)
        // }
        // ,
        downloadSong: function() {
            var anchor = document.createElement('a')
            var seqString = this.sequence.toUpperCase()
            // stop any previous song
            this.stopSong()
            // variables required from this
            var tempo = this.tempo
            var acidsToNotes = this.acidsToNotes
            var setMusicDelayDownload = this.setMusicDelayDownload
            Tone.Offline(function(Transport){
                var synth = new Tone.Synth().toMaster()
                console.log(synth)
                var startingTime = 1
                for (var i=0; i<seqString.length; i++) {
                    var acid = seqString[i]
                    if (acid in acidsToNotes) {
                        var note = acidsToNotes[acid]
                        var relativeTime = (i*tempo + startingTime)
                        setMusicDelayDownload(note, tempo, relativeTime, synth, Transport)
                    }
                }
                Transport.start(0)
            }, tempo * (seqString.length + 2)).then(function(buffer){
                console.log('downloading')
                console.log(buffer)
                var audioBuffer = buffer._buffer
                console.log(audioBuffer)
                var wav = audioBufferToWav(audioBuffer)
                var blob = new window.Blob([ new DataView(wav) ], {
                type: 'audio/wav'
                })
                var url = window.URL.createObjectURL(blob)
                anchor.href = url
                anchor.download = 'audio.wav'
                anchor.click()
                window.URL.revokeObjectURL(url)
            })
        },
        playOffline: function(anchor, seqString, synth, context) {
            console.log('playing offline')
            var startingTime = 1
            for (var i=0; i<seqString.length; i++) {
                var acid = seqString[i]
                if (acid in this.acidsToNotes) {
                    var note = this.acidsToNotes[acid]
                    var relativeTime = (i*this.tempo + startingTime)
                    this.setMusicDelayDownload(note, this.tempo, relativeTime, synth)
                }
            }
            Tone.Transport.start(0)
            context.render().then(buffer => {
                console.log('downloading')
                console.log(buffer)
                var audioBuffer = buffer._buffer
                console.log(audioBuffer)
                var wav = audioBufferToWav(audioBuffer)
                var blob = new window.Blob([ new DataView(wav) ], {
                    type: 'audio/wav'
                })
                var url = window.URL.createObjectURL(blob)
                anchor.href = url
                anchor.download = 'audio.wav'
                anchor.click()
                window.URL.revokeObjectURL(url)
            })
        },
        downloadSongDefault: function() {
            var anchor = document.createElement('a')
            // var audioContext = new (window.AudioContext || window.webkitAudioContext)()
            Tone.Offline(function(Transport){
                var osc = new Tone.Oscillator().toMaster()
                Transport.schedule(function(time){
                    osc.start(time).stop(time + 0.1)
                }, 1)
                Transport.start(0.2)
            }, 4).then(function(buffer){
                // returns a promise, with Buffer, expect ArrayBuffer
                //do something with the output buffer
                // console.log(resp)
                // audioContext.decodeAudioData(resp, function (buffer) {
                    var audioBuffer = buffer._buffer
                    console.log(audioBuffer)
                    // var wav = bufferToWav(buffer._buffer)
                    console.log(audioBufferToWav)
                    var wav = audioBufferToWav(audioBuffer)
                    var blob = new window.Blob([ new DataView(wav) ], {
                    type: 'audio/wav'
                    })
                    var url = window.URL.createObjectURL(blob)
                    anchor.href = url
                    anchor.download = 'audio.wav'
                    anchor.click()
                    window.URL.revokeObjectURL(url)
                // }, function () {
                //     throw new Error('Could not decode audio data.')
                // })
            })
        },
        setMusicDelay: function(note, tempo, relativeTime) {
            Tone.Transport.schedule((time) => {
                this.instrumentsTone[this.selectedInstrument].triggerAttackRelease(note, tempo, time)
            }, relativeTime)
        },
        setMusicDelayDownload: function(note, tempo, relativeTime, synth) {
            Tone.Transport.schedule((time) => {
                synth.triggerAttackRelease(note, tempo, time)
            }, relativeTime)
        },
        stopSong: function() {
            console.log("Stopping the song")
            // Stop, rewind and clear all events from the transport (from previous plays)
            Tone.Transport.stop();
            Tone.Transport.position = 0;
            Tone.Transport.cancel();
        },
        clearSequence: function() {
            console.log("Clearing the sequence")
            this.sequence = "";
        },
        resetTuning: function() {
            this.acidsToNotes = acidsToNotesOriginal
        },
        updateSelected: function(event, aminoacid) {
            var note = event.target.value
            console.log("Changing: ", aminoacid, note)
            this.acidsToNotes[aminoacid] = note
        },
    },
    data () {
        return {
            publicPath: process.env.BASE_URL,
            projectAcronym: "DPIM",
            projectName: "DNA Protein Into Music",
            sequence: "",
            lastTime: 0,
            visibleSequence: '',
            tempo: 0.25,
            selectedInstrument: "Piano",
            // instruments: [
            //     "bass-electric", "bassoon", "cello", "clarinet", "contrabass", "flute", "french-horn", "guitar-acoustic", "guitar-electric", "harmonium", "harp", "organ", "piano", "saxophone", "trombone", "trumpet", "tuba", "violin", "xylophone"
            // ],
            instruments: [
                "Bebop Organ", "Peel Guitar", "Piano", "Soft Piano",
                // "Celtic Harp" foi excluída por falta de notas
            ],
            aminoacids: aminoacids,
            notes: notes,
            musicSheet: {
                "created": false,
                "visible": false
            },
            acidsToNotes: {
                "L": "C2", "I": "D2", "V": "E2", "P": "F#2", "F": "G2",
                "M": "A2", "W": "B2", "A": "C3", "C": "D3", "G": "E3",
                "Y": "F#3", "T": "G3", "S": "A3", "H": "B3", "Q": "C4",
                "K": "D4", "N": "E4", "E": "F#4", "D": "G4", "R": "A4",
            },
            showAdvanced: serverBus.showAdvanced,
            audioLoaded: false,
            instrumentsTone: null,
            audioLoadedOffline: true,
        }
    },
    created() {
        // Using the server bus to listen to option changes
        // serverBus.$on('advancedOptions', (selectedOption) => {
        //     this.showAdvanced = selectedOption
        //         console.log('listening', this.showAdvanced)
        // });
        console.log('created')
        // code to disable the buttons - temporarily disabled
        this.instrumentsTone = SampleLibrary.load({
            instruments: this.instruments,
            ext: ".[wav|mp3|ogg]",
            baseUrl: "tonejs-instruments/samples/",
            // baseUrl: "https://musical-proteins.web.app/tonejs-instruments/samples/"
        })

        Tone.Buffer.on('load', () => {
            console.log('loaded tunes')
            this.audioLoaded = true
        })
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face { font-family: Dosis; src: url('../assets/Dosis-Light.ttf'); }
.title {
        font-family: "Open Sans"
}
.subtitle {
     font-family: Dosis;
     color: #bbbbbb;
     font-size: 60px;
     text-align: center;
}
.firstletter {
        font-weight: 700;
        color: #007bff;
}
.inline-select {
        display: block;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 5px;
        padding-left: 5px;
        font-family: "Open Sans";
}
#notes-selection{
    min-height: 250px;
}

.container-fluid {
    column-count: 4;
    column-rule-style: double;
}

.align-right{
        text-align: right;
}
.clearfix {
     overflow: auto;
}
.clearfix::after {
    content: "";
    clear: both;
    display: table;
}
.maxsize {
    margin-right: auto;
    margin-left: auto;
    max-width: 992px; /* or 950px */
}
#musicSheetContainer {
    overflow: scroll;
}

.playbuttons button {
    margin-right: 6px;
}

</style>
